import groupBy from "lodash/groupBy";
import AutoQueryController from "servicestack/auto-query/auto-query.controller";
import Product from "emun.shopping/product.model";
import basicController from "servicestack/basic.controller.properties";
import labels from "emun.order/_labels";
import resolve from "ioc/resolve";
import orderConfig from "emun.order/order.config";

export default class PartsEntryGridController extends AutoQueryController {
  getQueries() {
    const $ctrl = this;
    //console.info("loading", this);
    basicController($ctrl);
    $ctrl.orderConfig = orderConfig;
    $ctrl.imageSize = $ctrl.imageSize || "xxxxxs";
    //console.debug("$ctrl.parts", $ctrl.parts.filter(item => item.id != ""));
    $ctrl.parts = $ctrl.parts.filter((item) => item.id != "");
    console.debug("$ctrl.parts1", $ctrl.parts);
    if ($ctrl.$session.isAgency() && $ctrl.$cart.vendorId == undefined) {
      $ctrl.productIds = $ctrl.parts.map((part) =>
        part.VendorId != undefined
          ? part.ProductId.replace(part.VendorId + ".", "") ||
            part.id.replace(part.VendorId + ".", "")
          : part.ProductId || part.id
      );
    } else {
      $ctrl.productIds = $ctrl.parts.map((part) => part.ProductId || part.id);
    }

    //console.debug("$ctrl.productIds", $ctrl.productIds);
    if ($ctrl.$session.isAgency()) {
      $ctrl.productIds = $ctrl.productIds.map(function (x) {
        return x.replace($ctrl.$cart.vendorId + ".", "");
      });
    }
    //console.debug("$ctrl.productIds1", $ctrl.productIds);
    $ctrl.labels = labels;

    $ctrl.$on("refreshPartsEntryGrid", function () {
      $ctrl.productIds = $ctrl.parts.map((part) => part.ProductId || part.id);
      if ($ctrl.$session.isAgency()) {
        $ctrl.productIds = $ctrl.productIds.map(function (x) {
          return x.replace($ctrl.$cart.vendorId + ".", "");
        });
      }
      //if (JSON.stringify($ctrl.productIds) !== JSON.stringify($ctrl.$queries['query'].criteria.ManufacturerNumberIn)) {
      $ctrl.$queries["query"].criteria.ManufacturerNumberIn = $ctrl.productIds;
      $ctrl.load();
      //}
    });
    //console.info("$ctrl.labels", $ctrl.labels);
    //console.debug("$ctrl.parts", $ctrl.parts);
    //console.debug("$ctrl.productIds", $ctrl.productIds);
    //console.debug("$ctrl.productIds scrub", $ctrl.productIds.map(function (x) { return x.replace($ctrl.$cart.vendorId + ".", "") }));

    return {
      query: {
        url: `QueryProducts.json?IncludeInactive=1&PartsEntryGridController=1`,
        criteria: {
          IncludeInactive: true,
          ManufacturerNumberIn: $ctrl.productIds.join(","),
          vendorId:
            $ctrl.$session.isAgency() && $ctrl.product
              ? $ctrl.product.vendorId
              : $ctrl.mode != 'part' && $ctrl.$cart.vendorId
              ? $ctrl.$cart.vendorId
              : undefined,
        },
        pageSize: $ctrl.productIds.length,
        orderBy: "Id",
        autoLoad: true,
        httpMethod: "POST",
        onLoaded(args) {
          $ctrl.missingItems = [];
          $ctrl.$cart.bus.validationErrors = [];
          if (!args.results.length && $ctrl.$queries["query"].criteria.ManufacturerNumberIn) {
            $ctrl.$queries["query"].criteria.ManufacturerNumberIn = undefined;
            $ctrl.$queries["query"].criteria.UpcCodeIn = $ctrl.productIds.join(",");
            $ctrl.load();
                   
          } else {
            $ctrl.parts.forEach(function (p) {
              if (
                args.results.filter(
                  i =>
                    i.manufacturerNumber === p.ProductId ||
                    i.manufacturerNumber === p.id ||
                    i.id === p.ProductId ||
                    i.id === p.id ||
                    (i.upcCode && (i.upcCode === p.ProductId || i.upcCode === p.id))
                ).length < 1
              ) {
                console.debug("Items Does not exist", p);
  
                if (p.id.toLowerCase() != "product" && p.id.toLowerCase() != "productid" && p.id.toLowerCase() != "item") {
                  $ctrl.missingItems.push(p.ProductId || p.id);
                }
                
              }
            });
            console.info("missing items", $ctrl.missingItems);
            if ($ctrl.missingItems.length > 0) {
              $ctrl.$cart.bus.validationErrors.push([
                {
                  errorCode: "-1",
                  fieldName: "Product",
                  message: $ctrl.missingItems.join(", ") + " cannot be added",
                },
              ]);
            }
  
            args.results.forEach(function (obj) {
              obj.priceOverride = obj.price;
              var filteredParts = $ctrl.$session.isAgency()
                ? $ctrl.parts.filter((part) =>
                    part.VendorId != undefined
                      ? obj.manufacturerNumber ===
                          part.ProductId.replace(part.VendorId + ".", "") ||
                        (obj.manufacturerNumber || "").toUpperCase() ===
                          (part.id || "").toUpperCase() ||
                        (obj.upcCode || "").toUpperCase() ===
                          (part.id || "").toUpperCase() 
                      : (obj.manufacturerNumber || "").toUpperCase() ===
                        (part.ManufacturerNumber || "").toUpperCase() ||
                        (obj.upcCode || "").toUpperCase() ===
                        (part.id || "").toUpperCase() ||
                        (obj.manufacturerNumber || "").toUpperCase() ===
                        (part.id || "").toUpperCase() 
                  )
                : $ctrl.parts.filter(
                    (part) =>
                      obj.id === part.ProductId || obj.upcCode === part.ProductId ||
                      (obj.id || "").toUpperCase() ===
                        (part.id || "").toUpperCase() ||
                      (obj.upcCode || "").toUpperCase() ===
                        (part.id || "").toUpperCase() 
                  );
              if (filteredParts.length > 0) {
                //console.info("BL*** $ctrl.mode", $ctrl.mode);
                obj.qtyInPart = filteredParts[0].Qty;
                if ($ctrl.mode === "kit") {
                  if (!$ctrl.orderConfig.dontDefaultKitQty) obj.qty = obj.qtyInPart;
                } else if (
                  $ctrl.product &&
                  (obj.id === $ctrl.product.id || obj.id === $ctrl.product.upcCode) &&
                  $ctrl.product.quantity
                ) {
                  //console.info("BL*** got here 1", $ctrl.product.quantity);
                  obj.qty = $ctrl.product.quantity;
                } else if (filteredParts[0].qty) {
                  //console.info("BL*** got into filteredParts[0].qty", filteredParts[0].qty);
                  obj.qty = parseInt(filteredParts[0].qty);
                  if (obj.minimumOrderQty > obj.qty)
                    obj.qty = obj.minimumOrderQty;
                  if (obj.purchaseIncrement && obj.qty % obj.purchaseIncrement)
                    obj.qty =
                      obj.qty +
                      obj.purchaseIncrement -
                      (obj.qty % obj.purchaseIncrement);
                } else {
                  if ($ctrl.defaultMinimum) {
                    obj.qty = obj.minimumOrderQty;
                  }
                }
                if (
                  $ctrl.$cart &&
                  $ctrl.$cart.hasItem &&
                  $ctrl.$cart.hasItem(obj.id)
                ) {
                  obj.qty = $ctrl.$cart.itemIndex[obj.id].qtyPurchased;
                  obj.price = $ctrl.$cart.itemIndex[obj.id].price;
                  obj.priceOverride = $ctrl.$cart.itemIndex[obj.id].price;
                  obj.notes = $ctrl.$cart.itemIndex[obj.id].notes;
                  obj.shipOn = $ctrl.$cart.itemIndex[obj.id].shipOn;
                }
              }
            });
  
            $ctrl.availability.criteria.ProductIdIn = args.results
              .map((p) => p.id)
              .join(",");
            $ctrl.availability.load();
          }

        },
        scrub(response) {
          response.data.results = _.sortBy(response.data.results, (p) =>
            $ctrl.parts.findIndex((y) => y.id === p.manufacturerNumber)
          );
          $ctrl.results = response.data.results = Product.map(
            response.data.results
          );
        },
      },
      availability: {
        url: `QueryProductAvailability.json?PartsEntryGridController=1`,
        criteria: {
          StatusNotIn: ["NOSHOW"],
          IncludeInactive: true,
        },
        pageSize: 888, // $ctrl.productIds.length,
        autoLoad: false,
        httpMethod: "POST",
        onLoaded(args) {
          $ctrl.pwa = groupBy(args.results, "productId");
        },
      },
    };
  }
}
